import { forwardRef, useState } from "react";
import {
    Box,
    Dialog,
    Divider,
    Slide
} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactComponent as QuestionIcon } from '../assets/question.svg';
import { Swiper, SwiperSlide, FreeMode } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

SwiperCore.use([Pagination])

function HomeHelpCalorie() {
    const [open, setOpen] = useState(false);
    const openClick = () => {
        setOpen(true);
    };
    const closeClick = () => {
        setOpen(false);
    };
    return (
        <>
            <Dialog fullScreen open={open} onClose={closeClick} TransitionComponent={Transition}>
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '25px 0 0 10px',
                            fontSize: '22px'
                        }}>
                        칼로리포인트 안내
                    </Box>
                </Box>
                <Divider />

                <Swiper
                    // slidesOffsetBefore={24}
                    // slidesOffsetAfter={24}
                    grabCursor={true}
                    slidesPerView={1}
                    className="mySwiper"
                    pagination={{ clickable: true }}
                    style={{
                        width: '100%',
                        height: '100%',
                        zIndex: '1',
                        '.swiperPaginationBullets' : {
                            bottom: 0
                        }
                    }}
                >
                    <SwiperSlide>

                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '20px',
                                padding: '20px',
                                borderRadius: '5px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    칼로리포인트는 운동하면서 소모한 칼로리를 포인트화한 것입니다.
                                    <br></br>
                                    칼로리게이지 1,000kcal 달성마다 1,000캐시가 자동으로 발급되며 게이지는 0으로 초기화됩니다..
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/calorie_help01.png'
                                style={{
                                    width: '100%',
                                }} />
                        </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '20px',
                                // marginBottom: '0',
                                padding: '20px',
                                borderRadius: '5px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    메인화면 칼로리포인트 클릭시 일별 칼로리포인트 획득 내역을 확인할 수 있습니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/calorie_help02.png'
                                style={{
                                    width: '100%'
                                }} />
                        </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Box
                            sx={{
                                // background: '#f1f2f2',
                                margin: '20px',
                                // marginBottom: '0',
                                padding: '20px',
                                borderRadius: '5px'
                            }}>
                            <Box
                                sx={{
                                    fontSize: '14px'
                                }}>
                                <Box>
                                    칼로리포인트(칼로리시스템)는 하기 내용으로 특허 출원중입니다.
                                    <br></br>
                                    이를 무단복제하는 경우, 법적 조치가 들어갈 수 있으므로 유의해주시기 바랍니다.
                                </Box>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                            <img src='/img/calorie_help03.jpg'
                                style={{
                                    width: '90%'
                                }} />
                        </Box>
                    </SwiperSlide>
                </Swiper>

            </Dialog>

            <QuestionIcon
                style={{
                    width: '16px',
                    height: '16px',
                    position: 'absolute',
                    top: '0',
                    right: '12px',
                }}
                onClick={openClick} />
        </>
    )
}

export default HomeHelpCalorie;